/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'wsn-searchable-select',
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.scss']
})
export class SearchableSelectComponent<TData> {
  @Input() selected?: TData;
  @Input() selectRequired: boolean;
  @Input() hint?: string;
  @Input() searchProperty?: string;
  @Input() showLongNameTooltip = false;

  @Input() allItems: TData[];
  public searchValue?: string;

  @Output() onChangeSelection = new EventEmitter<TData>();

  get filteredItems() {
    if (!this.searchValue) {
      return this.allItems;
    }

    const lowerCaseValue = this.searchValue.toLowerCase();

    return this.allItems.filter((element) => {
      const lowerCaseElementValue = (element[this.searchProperty] || element).toLowerCase();
      return lowerCaseElementValue.includes(lowerCaseValue);
    });
  }

  getTooltip(item: TData): string {
    if (!this.showLongNameTooltip) {
      return '';
    }
    const name = this.searchProperty ? item[this.searchProperty] : item;
    return name && name.length > 36 ? name : '';
  }

  onSelect(selected: TData) {
    this.onChangeSelection.emit(selected);
  }
}
